/**
 * MCP manifest API — fetches live tool definitions from the gateway.
 */

import { useQuery } from '@tanstack/react-query';

export interface ManifestTool {
  name: string;
  description: string;
}

export interface ManifestGroup {
  service: string;
  label: string;
  tools: ManifestTool[];
}

export interface ToolManifest {
  version: string;
  generatedAt: string;
  groups: ManifestGroup[];
  totalTools: number;
}

export async function fetchToolManifest(): Promise<ToolManifest> {
  const res = await fetch('/api/mcp/manifest', { credentials: 'include' });
  if (!res.ok) throw new Error(`Failed to fetch tool manifest: ${res.status}`);
  return res.json();
}

export function useToolManifest() {
  return useQuery({
    queryKey: ['mcp', 'manifest'],
    queryFn: fetchToolManifest,
    staleTime: 60 * 60 * 1000,  // 1 hour
    gcTime: 24 * 60 * 60 * 1000, // 24 hours
    retry: 1,
  });
}
